import styled from "styled-components";
import { DhlImage, DhlText } from "@dhl-official/react-library";
import { Card } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const DhlImageStyled = styled(DhlImage)`
  max-width: 6.4rem;
  @media screen and (min-width: ${breakpoints.desktop}) {
    max-width: 8.4rem;
  }
`;

export const NoOffersWrapper = styled(Card)`
  margin: 0 var(--dui-size-space-10x);

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin: var(--dui-size-space-10x) 0;
    padding: var(--gaq-size-space-30px) var(--dui-size-space-40x);
    text-align: center;
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: var(--gaq-size-space-30px) var(--gaq-size-space-180px);
    margin-left: auto;
    margin-right: auto;
    max-width: 100rem;
  }
`;

export const NoOffersTitle = styled(DhlText)`
  & span {
    font-size: var(--dui-size-font-xl);

    @media screen and (min-width: ${breakpoints.desktop}) {
      font-size: var(--dui-size-font-6xl);
    }
  }
`;

export const NoOffersResultDescription = styled(DhlText)`
  text-align: center;
  & span {
    font-size: var(--dui-size-font-xs);

    @media screen and (min-width: ${breakpoints.desktop}) {
      font-size: var(--dui-size-font-md);
    }
  }
`;
